import { ROUTE_IDS } from '@/app/router/route-constants';

export const tenantNavigation = [
  { routeId: ROUTE_IDS.DASHBOARD },
  { routeId: ROUTE_IDS.ASSIGNMENTS },
  { routeId: ROUTE_IDS.DEAL_PROPOSALS },
  { routeId: ROUTE_IDS.DEALS_IN_PROGRESS },
  { routeId: ROUTE_IDS.DEALS_COMPLETED },
  { routeId: ROUTE_IDS.CLIENTS },
  { routeId: ROUTE_IDS.SUPPLIERS },
  { routeId: ROUTE_IDS.STAFF },
  { routeId: ROUTE_IDS.CALENDAR },
  { routeId: ROUTE_IDS.DOCUMENTS },
  { routeId: ROUTE_IDS.ACCOUNTING },
  { routeId: ROUTE_IDS.EXPENSES },
  { routeId: ROUTE_IDS.WORKSPACE_USERS },
  { routeId: ROUTE_IDS.SETTINGS },
];
